<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Nova Categoria de Vídeo</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="name">Nome</label>
                            <input type="text" class="form-control" name="name" v-model="categoryVideo.name">
                        </div>
                        <div class="col-md-6">
                            <label for="photo">Imagem da Categoria</label>
                            <input type="file" name="photo" id="photo">
                        </div>
                    </div>

                    <hr>

                    <!-- <input type="submit" class="btn btn-success" value="salvar" v-on="click: onClick"> -->
                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/categoryVideo" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                categoryVideo: {
                    name: '',
                },
                errors: undefined
            }
        },
        methods: {
            save: function () {
                const api = this.$store.state.api + 'categoryVideo';
                const self = this;

                let form  = new FormData();
                let photo = document.getElementById('photo');

                form.append('name', self.categoryVideo.name);
                form.append('photo', (photo.files[0]) ? photo.files[0] : '');

                self.$http.post(api, form)
                    .then((response) => {
                        self.categories = response.data.data;
                        self.tableData = self.categories;

                        self.$message('Sucesso', `Categoria cadastrada com sucesso`, 'success');

                        self.categoryVideo = {
                            name: '',
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    })
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


</style>



// WEBPACK FOOTER //
// src/components/CategoryVideo/Add.vue